import { Injectable } from '@angular/core';
import { RequestService } from '@df/api/request/request.service';
import { Paypal } from '@df/module-paypal/paypal.namespace';

@Injectable({ providedIn: 'root' })
export class PaypalService {
    constructor(private request: RequestService) {}
    /**
     * Loads paypal checkout script
     * @returns {Promise<undefined>}
     */
    async loadCheckout(): Promise<void> {
        await this.request.loadScriptAsync(Paypal.SCRIPTS.CHECKOUT);
    }

    /**
     * Returns paypal Button
     */
    getButton(): Paypal.IButton | undefined {
        return typeof window === 'undefined' ? undefined : window.paypal?.Button;
    }

    buttons(configuration: Paypal.ISDKButtonsConfiguration): Paypal.ISDKButton | undefined {
        if (typeof window === 'undefined') {
            return undefined;
        }
        return window.paypal?.Buttons?.(configuration);
    }
}
